import React, { useEffect, useState } from "react";
import HospitalLinkForm from "../../../components/HospitalLinks/HospitalLinkForm";
import { useSession } from "../../../context/SessionContext";
import { useHospitals } from "../../../hooks/useHospitals";
import { t } from "../../../i18n";
import { Hospital } from "../../../types/hospital.types";
import { LinkedList } from "./LinkedList";

// Hospitais vinculados ao médico.
export const HospitalLinks: React.FC = () => {
  const { listMyHospitals, unlinkHospital, unlinking } = useHospitals();
  const { setMetadata } = useSession();
  const [hospitals, setHospitals] = useState<Hospital[]>([]);
  const [loadingList, setLoadingList] = useState(true);

  useEffect(() => {
    listMyHospitals().then((result) => {
      if (result) setHospitals(result.hospitals);
      setLoadingList(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUnlink = async (hospital: Hospital) => {
    if ((await unlinkHospital(hospital.id)) === null) return;
    setHospitals((prev) => prev.filter((h) => h.id !== hospital.id));
    // Mantém `metadata.hospitals` (lido por outras telas) igual ao que foi desvinculado aqui.
    setMetadata((prev) => ({ ...prev, hospitals: prev.hospitals.filter((h) => h.id !== hospital.id) }));
  };

  return (
    <LinkedList
      items={hospitals}
      loading={loadingList}
      loadingText={t("links.hospital.loading")}
      emptyText={t("links.hospital.empty")}
      unlinkTitle={t("links.hospital.unlinkTitle")}
      subtitle={(h) => h.email}
      busy={unlinking}
      onUnlink={handleUnlink}
      addForm={
        <HospitalLinkForm
          existingHospitals={hospitals}
          onLinked={(hospital) => setHospitals((prev) => (prev.some((h) => h.id === hospital.id) ? prev : [...prev, hospital]))}
        />
      }
    />
  );
};
